import React, { useEffect, useState } from 'react';
import { parseProps, componentIdGenerator } from './@uteis';
import BRTable from '../../assets/dsgov/js/components/table';

import Button from './Button';
import Select from './Select';
import SelectOption from './SelectOption';

import '../../assets/dsgov/css/components/table.css';
import './Datatable.css';

const Datatable = (_props) => {
  const props = parseProps(_props);
  const componentId = componentIdGenerator();

  const [component, setComponent] = useState(null);

  useEffect(() => {
    if (!component) {
      setComponent(new BRTable('br-table', window.document.querySelector(`.${componentId}`), 1));
    } else {
      component._setBehavior();
    }
  }, [props.children]);

  const deleteRows = () => {
    const checksSelected = component.component.querySelectorAll("tbody .is-selected [name='check'] [type='checkbox']");
    const selectedBar = component.component.querySelector('.selected-bar');

    const checksSelectedId = Object.values(checksSelected).map((el) => el.id);
    if (props.deleteRows) {
      props.deleteRows(checksSelectedId);
    }
    component._uncheckAllRows(checksSelected);
    selectedBar.classList.remove('is-active');
    selectedBar.querySelector('.info .count').innerHTML = 0;
  };

  let classes = `br-table is-datatable is-checkbox is-grid-small ${componentId}`;
  if (props.classes) classes = `${classes} ${props.classes}`;

  let title = null;
  if (props.title) title = <div className="title">{title}</div>;

  const actionsItems = props.actionsItems ? props.actionsItems : null;

  let footer = null;
  if (props.footer) {
    footer = (
      <div className="footer">
        <div className="items">
          <span>1-10 de 50 itens</span>
        </div>
        <div className="pagination">
          <div className="selectors">

            <Select
              small
              placeholder=" "
            >
              <SelectOption selected>1</SelectOption>
              <SelectOption>2</SelectOption>
              <SelectOption>3</SelectOption>
            </Select>
            <span>de 3 páginas</span>
            <span className="divider" />
          </div>
          <div className="arrows">
            <Button small circle>
              <i className="fa fa-chevron-left" />
            </Button>
            <Button small circle>
              <i className="fa fa-chevron-right" />
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes} id={props.id ? props.id : componentId}>
      <div className="header">

        <div className="top-bar">
          {title}
          {actionsItems}
        </div>
        <div className="selected-bar">
          <div className="info">
            <Button classes="primary mobile select-all">
              <i className="fas fa-minus-square" aria-hidden="true" />
            </Button>
            <span className="count">0</span>
            <span className="text" />
          </div>
          <div className="action-button">
            <Button
              small
              circle
              primary
              onClick={deleteRows}
            >
              <i className="fa fa-trash-alt" aria-hidden="true" />
            </Button>
          </div>

        </div>
      </div>
      <div className="responsive">
        {props.children}
      </div>
      {footer}
    </div>
  );
};

export default Datatable;
